import React from "react";
import { DATASET_FIELDS_LIMIT } from "../../config/appConfig";

export default function DatasetMetaPanel({ metadata, visible }) {
  if (!visible || !metadata?.columns?.length) return null;
  const columns = metadata.columns.slice(0, DATASET_FIELDS_LIMIT);
  const trimmed = metadata.columns.length > columns.length;
  return (
    <section className="meta-fields card" aria-live="polite">
      <div className="meta-fields-title">
        Dataset Columns ({metadata.columns.length})
      </div>
      <div className="meta-fields-grid">
        {columns.map((col) => (
          <span key={col} className="meta-field-chip">
            {col}
          </span>
        ))}
        {trimmed && <span className="meta-field-chip muted">+ more</span>}
      </div>
    </section>
  );
}
